export default __webpack_public_path__ + "static/media/LogoSN.51837c89.jpg";